import React, { FunctionComponent } from 'react';

import './publishing-sdk-card.scss';
import { PricingURL } from '../../../enviroment';

export const UpgradeCard: FunctionComponent<{ classes?: string }> = ({
    classes = 'border-goose-600 border-solid border',
}) => {
    return (
        <div
            className={`publishing-sdk-card flex flex-col mb-5 w-full bg-white p-6 rounded-12 ${classes}`}
        >
            <div className="publishing-sdk flex flex-col">
                <div>
                    <h3 className="font-medium">Upgrade Required</h3>
                    <p>
                        <a
                            href={PricingURL}
                            target="_blank"
                            rel="noreferrer"
                            className="text-16 text-green sdk-publishing-link"
                        >
                            Upgrade to the Business plan
                        </a>{' '}
                        to enable these AI-powered integrations for your APIs.
                    </p>
                </div>
            </div>
        </div>
    );
};
